import React, { useContext } from 'react'

export function loadEnvironmentVariables(): EnvironmentContextValues {
  return {
    googlePlaceAPIKey: process.env.GOOGLE_PLACE_API_KEY || '',
    deployEnv: process.env.DEPLOY_ENV || '',
    canonicalUrlRedirects: process.env.FF_CANONICAL_URL_REDIRECTS === 'true',
    customAdDisabled: process.env.FF_CUSTOM_AD_DISABLED === 'true'
  }
}

export type EnvironmentContextValues = {
  googlePlaceAPIKey: string
  deployEnv: string
  canonicalUrlRedirects: boolean
  customAdDisabled: boolean
}

export const EnvironmentContext = React.createContext<EnvironmentContextValues>({
  googlePlaceAPIKey: '',
  deployEnv: '',
  canonicalUrlRedirects: false,
  customAdDisabled: false
})

export const useEnvironmentContext = () => {
  return useContext(EnvironmentContext)
}

const EnvironmentProvider = ({
  children,
  environmentVariables
}: {
  children: React.ReactNode
  environmentVariables: EnvironmentContextValues
}) => {
  const value: EnvironmentContextValues = {
    googlePlaceAPIKey: environmentVariables.googlePlaceAPIKey,
    deployEnv: environmentVariables.deployEnv,
    canonicalUrlRedirects: environmentVariables.canonicalUrlRedirects,
    customAdDisabled: environmentVariables.customAdDisabled
  }

  return <EnvironmentContext.Provider value={value}>{children}</EnvironmentContext.Provider>
}

export default EnvironmentProvider
